import './i18n';
import CookieConsent from '@n2-common/components/CookieConsent';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BackendContextProvider } from '@n2-common/components/BackendContext';
import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
    throw new Error("Missing root element with id='root' in DOM");
}

const provider = (rootEl.dataset.provider || 'O1') as Backend;

ReactDOM.createRoot(rootEl as HTMLElement).render(
    <React.StrictMode>
        <CookieConsent country="NO" />
        <BackendContextProvider provider={provider} country={'NO'}>
            <App antiforgeryToken={rootEl.dataset.antiforgerytoken} />
        </BackendContextProvider>
    </React.StrictMode>
);
